var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FeatureListItemCore } from '@core-front/feature-list';
import { default as Grid, GridColumn } from '@telia-front/grid';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
const FeatureListItem = (props) => {
    const { grid } = props, rest = __rest(props, ["grid"]);
    return (React.createElement(FeatureListItemCore, Object.assign({}, rest, { components: {
            Grid: gridProps => React.createElement(Grid, Object.assign({}, gridProps, grid, { verticalGutter: "smedium", wrap: ['md'], noWrap: ['xs'] })),
            GridColumn,
            Icon,
            Image,
        } })));
};
export { FeatureListItem as default };
